import LocalizedStrings from 'react-localization';
import { LanguageCode } from '../store/useLanguageCodeStore';

const strings = new LocalizedStrings({
  [LanguageCode.ko]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: '진료 예약하기(초진)',
    drpetitFollowUpVisitBooking: '진료 예약하기(재진)',
    logout: '인증해제',
    /**
     * Custom pages
     */
    nbomLandingTitle1: '당신의 아름다움이 피어나는 곳,',
    nbomLandingTitle2: '미소앤봄의원입니다.',
    nbomLandingReservationDescription:
      '기다리지 않고 빠르게\n예약을 진행해보세요.',

    /**
     * AI 코디 상담요청
     */
    completeChatRequest:
      '접수가 완료되었어요.\n담당자 확인 후 최대한 빨리 답변드릴게요.',
    chatRequestWelcomeTitle: '고객님 안녕하세요!\n담당자 연결이 필요하신가요?',
    chatRequestWelcomeDesc:
      '담당자 연결은 병원 운영시간 내에 차근차근 확인하여 빠르게 답변드릴게요.',
    connectChatRequired: '네 연결이 필요해요',
    connectChatLater: '아니요 다음에 다시 할게요',

    /**
     * 리뷰 질문
     */
    reviewCommentPlaceholder: '자유로운 의견을 입력해주세요',
    visitDate: '방문일',
    reviewTitleService: '전반적인 서비스 만족도는 어떠셨나요?',
    reviewTitleTherapist: '관리사 대하여 만족하셨나요?',
    reviewTitleDoctor: '의사 선생님은 친절하였나요?',
    reviewTitleTreatment: '받으신 시술은 만족하셨나요?',
    reviewTitleConsultant: '상담원은 친절하였나요?',
    reviewTitleVisit: '전반적인 방문 경험은 만족스러우신가요?',
    reviewTitleReturn: '전반적인 퇴원 경험은 만족스러우신가요?',
    reviewTitleContent: '기타 추가적인 의견을 작성해주세요',
    addReview: '리뷰 등록',
    completeReview: '리뷰 등록 완료',
    completeReviewDescription:
      '{partnerName}에 방문해주셔서 감사드려요!\n작성해 주신 리뷰를 바탕으로\n더 좋은 서비스로 보답드리겠습니다.',

    /**
     * 예약
     */
    noAvailableReservationTime: '예약 가능한 시간이 없습니다',
    unavailableTreatment: '예약불가 시술',
    productOptionUpdatedNotice:
      '시술 정보가 변경되어 반영했어요. 확인 후 다시 진행해주세요.',
    productOptionRemovedNotice: '예약할 수 없는 시술이 제외되었어요.',
    noAvailableReservationTimeDesc1:
      '해당 날짜에는 담당 원장님 부재로 예약이 어렵습니다.',
    noAvailableReservationTimeDesc2:
      '다른 날을 선택하거나 시술을 조정해주세요.',
    productPriceNoticeDesc: '가격은 정보용이며, 결제는 현장에서 진행됩니다.',
    treatmentReservationTag: '시술예약',
    consultingReservationTag: '상담예약',
    noRecentReservation: '최근 진료 내역이 없습니다',
    selectRecentReservationTitle: '최근 진료일을 선택해 주세요',
    selectRecentReservationTitlePostfix: '(최대 3건 노출)',
    treatmentCategoryTitle: '진료분야',
    selectedConsultingCategoryTitle: '추가상담',
    extraConsultingCategoryTitle: '추가 가능한 상담',
    extraConsultingCategoryTitlePostFix: '(복수 선택 가능)',
    primaryTreatmentCategoryPlaceholder: '진료분야 (1차)',
    secondaryTreatmentCategoryPlaceholder: '진료분야 (2차)',
    revisitReservationButtonTitle: '최근 진료 재예약',
    treatmentReservationButtonTitle: '시술 예약',
    consultingReservationButtonTitle: '상담 예약',
    selectReservationMenu: '예약 메뉴를 선택해 주세요',
    bookAppointment: '진료 예약하기',
    thisMonthEvent: '이달의 이벤트',
    reservationAvailable: '예약 가능',
    reservationUnavailable: '예약 불가',
    reservedProducts: '{productOptionName} 외 {n}건',
    noExpectPrice: '상담 후 안내',
    reservationCancelPolicy1:
      '예약신청 상태에서는 예약일시 변경, 예약 취소가 가능해요',
    reservationCancelPolicy2:
      '예약확정 상태부터는 예약일시 변경, 예약 취소가 불가능해요. 부득이하게 방문하지 못하는 경우 직접 채널톡 1:1 상담 혹은 전화상담으로 예약을 취소해주세요',
    filterCategoriesAndEvents: '카테고리 및 이벤트',
    reservationStatusCancel: '예약취소',
    reservationStatusRequest: '예약신청',
    reservationStatusConfirm: '예약확정',
    completeReservationCancel: '예약이 취소되었습니다',
    completeEditReservationDate: '예약날짜 변경이 완료되었습니다',
    confirmCancelReservation: '예약을 취소하시겠어요?',
    confirmEditReservation: '선택하신 날짜로 예약을 변경하시겠어요?',
    cancel: '취소',
    cancelReservation: '예약 취소',
    editReservation: '예약 변경',
    searchPlaceholder: '검색어를 입력해주세요',
    event: '이벤트',
    aiCodiRecommend: 'AI상담사 추천',
    allTermsAgreement: '전체 약관에 동의',
    termsEssential: '[필수]',
    termsOptional: '[선택]',
    allTreatment: '전체 시술',
    reservationLandingGreeting: '안녕하세요🙂\n{partnerName} 입니다',
    reservationLandingDescription: '아래 메뉴를 통해 예약진행을 도와드릴게요.',
    treatmentSelectReservation: '시술선택예약',
    visitConsultingReservation: '재진 / 방문상담예약',
    reservationHistoriesButton: '예약조회 / 변경 / 취소',
    makeReservation: '예약하기',
    reservationDetail: '예약상세',
    normalBusiness: '정상진료',
    selectTime: '시간 선택',
    selectDate: '방문일 선택',
    selectTreatmentCategory: '진료 분야 선택',
    selectTreatmentCategoryDesc: '원하는 진료 분야를 선택해 주세요',
    requestReservation: '예약신청',
    reservationVerifyTitle: '예약 정보를 확인해주세요',
    reservationRequestNotice: '병원에서 확인 후 예약을 확정합니다.',
    reservationDate: '예약일',
    reservationDateTime: '예약일시',
    expectedPaymentPrice: '결제 금액',
    expectedPrice: '예상금액',
    consultingMemo: '상담 신청 내용',
    noConsultingMemo: '없음',
    selectedTreatments: '선택 시술',
    requestAuth: '인증요청',
    consultingMemoPlaceholder:
      '피부 고민을 미리 적어 주시면 상담을 더 빠르게 받으실 수 있어요.\n동행분이 있다면 동행분 성함을 기입해주세요!',
    namePlaceholder: '성함을 입력해주세요',
    firstNamePlaceholder: '이름을 입력해주세요',
    lastNamePlaceHolder: '성을 입력해주세요',
    passportNameGuideDescription: '',
    phonePlaceholder: '연락처를 입력해주세요',
    emailPlaceholder: '이메일을 입력해주세요',
    authNoPlaceholder: '인증번호를 입력해주세요',
    resendAuth: '재전송',
    resendAuthTimer: '재전송 ({0}초)',
    validationGuide: '필수 정보를 올바르게 입력해주세요.',
    unitEA: '개',
    confirm: '확인',
    priceUnit: '원',
    completeReservation: '예약 신청 완료',
    completeReservationDesc: '병원에서 확인 후, 예약이 확정되면 알려드려요!',
    confirmReservation: '예약 완료',
    confirmReservationDesc:
      '예약 시간에 맞춰 병원에 방문해 주시면 돼요.\n기다리고 있을게요! 😊',

    includeVAT: '(VAT포함)',
    excludeVAT: '(VAT별도)',
    next: '다음',
    reservationHistories: '예약 리스트',
    consultingReservation: '방문/상담',
    unitReservationProductEA: '건',
    all: '전체',
    aiCodeRecommendProductFilter: '추천 시술 😀',
    exhibitionProductFilter: '기획전 시술 😀',
    feedbackAuthRequestSuccess:
      '휴대폰으로 전송된 인증번호 6자리를 입력해주세요.',
    feedbackAuthRequestSuccessEmail:
      '이메일로 전송된 인증번호 6자리를 입력해주세요.',
    noReservationHistories: '등록된 예약목록이 없습니다',
    noProducts: '등록된 시술정보가 없습니다',
    reservationCustomerInfo: '예약자 정보',
    reservationCustomerName: '예약자명',
    reservationCustomerPhone: '연락처',

    needConsultation: '상담필요',
    writeAnonymously: '익명으로 남기기',
    birth: '생년월일',
    birthInputGuide: '생년월일을 입력해주세요',
    invalidBirthInputMessage: '올바른 생년월일을 입력해주세요.',
  },
  [LanguageCode.en]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: 'Book Now (First visit)',
    drpetitFollowUpVisitBooking: 'Book Now (Follow-up)',
    logout: 'Sign out',
    /**
     * Custom pages
     */
    nbomLandingTitle1: 'Glowing Skin,\nBlooming Beauty',
    nbomLandingTitle2: 'with MeSOnBOM',
    nbomLandingReservationDescription: 'Quick & Easy\nreservation.',

    /**
     * AI 코디 상담 요청
     */
    completeChatRequest:
      'Your request has been received.\nWe will respond as soon as possible after reviewing it.',
    chatRequestWelcomeTitle:
      'Hello!\nDo you need to be connected to a consultant?',
    chatRequestWelcomeDesc:
      'We will review your request during hospital operating hours and respond as quickly as possible.',
    connectChatRequired: 'Yes, I need to be connected',
    connectChatLater: "No, I'll do it later",

    /**
     * 리뷰 질문
     */
    reviewCommentPlaceholder: 'Feel free to leave your comments',
    visitDate: 'Visit Date',
    reviewTitleService: 'How satisfied were you with the overall service?',
    reviewTitleTherapist: 'Were you satisfied with the therapist?',
    reviewTitleDoctor: 'Was the doctor friendly?',
    reviewTitleTreatment: 'Were you satisfied with the treatment you received?',
    reviewTitleConsultant: 'Was the consultant friendly?',
    reviewTitleVisit: 'Were you satisfied with your overall visit experience?',
    reviewTitleReturn:
      'Were you satisfied with your overall discharge experience?',
    reviewTitleContent: 'Please write any additional comments',
    addReview: 'Add Review',
    completeReview: 'Review Completed',
    completeReviewDescription:
      'Thank you for visiting {partnerName}!\nWe will use your feedback to improve our services.',
    writeAnonymously: 'Write anonymously',

    /**
     * 예약
     */
    noAvailableReservationTime: 'No available appointment times',
    unavailableTreatment: 'Unavailable treatment',
    productOptionUpdatedNotice:
      'Treatment details have changed and were updated. Please review and try again.',
    productOptionRemovedNotice:
      'Treatments that cannot be reserved were removed.',
    noAvailableReservationTimeDesc1:
      'The selected doctor is unavailable on this date.',
    noAvailableReservationTimeDesc2:
      'Please choose another date or adjust your selected treatments.',
    productPriceNoticeDesc:
      'Prices are for reference only; payment is made on-site.',
    treatmentReservationTag: 'Procedure Reservation',
    consultingReservationTag: 'Consultation Reservation',
    noRecentReservation: 'There are no recent reservation records',
    selectRecentReservationTitle: 'Please select your recent reservation date',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: 'Medical Field',
    selectedConsultingCategoryTitle: 'Additional Consultation',
    extraConsultingCategoryTitle: 'Consultations Available',
    extraConsultingCategoryTitlePostFix: '(Multiple Selections Available)',
    primaryTreatmentCategoryPlaceholder: 'Primary Medical Field',
    secondaryTreatmentCategoryPlaceholder: 'Secondary Medical Field',
    revisitReservationButtonTitle: 'Recent Appointment Rescheduling',
    treatmentReservationButtonTitle: 'Treatment Reservation',
    consultingReservationButtonTitle: 'Book Consultation',
    selectReservationMenu: 'Please select a reservation menu',
    bookAppointment: 'Book an Appointment',
    thisMonthEvent: "This month's Event",
    reservationAvailable: 'Available',
    reservationUnavailable: 'Unavailable',
    reservedProducts: '{productOptionName} and {n} more',
    noExpectPrice: 'Information provided after consultation',
    reservationCancelPolicy1:
      'You can change the reservation date and time or cancel the reservation while it is in the reservation request status.',
    reservationCancelPolicy2:
      'Once the reservation is confirmed, you cannot change the reservation date and time or cancel the reservation. If you are unable to visit, please cancel the reservation through a direct Channel Talk 1:1 consultation or phone consultation.',
    filterCategoriesAndEvents: 'Categories and Events',
    reservationStatusCancel: 'Cancel Reservation',
    reservationStatusRequest: 'Reservation Request',
    reservationStatusConfirm: 'Reservation Confirmed',
    completeReservationCancel: 'The reservation has been canceled',
    completeEditReservationDate: 'The reservation date has been changed',
    confirmCancelReservation: 'Do you want to cancel the reservation?',
    confirmEditReservation:
      'Do you want to change the reservation to the selected date?',
    cancel: 'Cancel',
    cancelReservation: 'Cancel Reservation',
    editReservation: 'Edit Reservation',
    searchPlaceholder: 'Please enter a search term',
    event: 'Event',
    aiCodiRecommend: 'AI Counselor Recommendation',
    allTermsAgreement: 'Agree to all terms',
    termsEssential: '[Required]',
    termsOptional: '[Optional]',
    allTreatment: 'All Treatments',
    reservationLandingGreeting: 'Hello, this is {partnerName}',
    reservationLandingDescription:
      'We will help you make a reservation through the menu below.',
    treatmentSelectReservation: 'Select Treatment Reservation',
    visitConsultingReservation: 'Visit Consultation Reservation',
    reservationHistoriesButton: 'My Bookings',
    makeReservation: 'Make a Reservation',
    reservationDetail: 'Reservation Details',
    normalBusiness: 'Normal Business',
    selectTime: 'Select Time',
    selectDate: 'Select Visit Date',
    selectTreatmentCategory: 'Select Treatment Category',
    selectTreatmentCategoryDesc: 'Choose the field for consultation',
    requestReservation: 'Request Reservation',
    reservationVerifyTitle: 'Please verify following reservation',
    reservationRequestNotice: 'Your booking will be confirmed upon approval.',
    reservationDate: 'Reservation Date',
    reservationDateTime: '[Book info.]\nReservation Date/Time',
    expectedPaymentPrice: 'Payment Amount',
    expectedPrice: 'Expected Price',
    consultingMemo: 'Consultation Request Details',
    noConsultingMemo: 'None',
    selectedTreatments: 'Selected Treatments',
    requestAuth: 'Auth',
    consultingMemoPlaceholder:
      'Let us know your skin concerns in advance, so you can receive consultation faster. If you have a companion, please enter their name as well!',
    namePlaceholder: 'Please enter your name',
    firstNamePlaceholder: 'First name',
    lastNamePlaceHolder: 'Last name',
    passportNameGuideDescription:
      'Please enter your English name exactly as shown on your passport, including spaces.',
    phonePlaceholder: 'Phone number',
    emailPlaceholder: 'Enter your email',
    authNoPlaceholder: 'Please enter the authentication number',
    resendAuth: 'Resend',
    resendAuthTimer: 'Resend ({0}s)',
    validationGuide: 'Please enter the required information correctly.',
    unitEA: 'ea',
    confirm: 'Confirm',
    priceUnit: 'KRW',
    completeReservation: 'Confirming your Booking',
    completeReservationDesc: "We'll notify you when your booking is confirmed!",
    confirmReservation: 'Reservation Completed',
    confirmReservationDesc:
      'Just drop by the hospital at your scheduled time. See you soon! 😊',
    includeVAT: '(VAT Included)',
    excludeVAT: '(VAT Excluded)',
    next: 'Next',
    reservationHistories: 'Reservation List',
    consultingReservation: 'Visit/Consultation',
    unitReservationProductEA: 'item',
    all: 'All',
    aiCodeRecommendProductFilter: 'Recommended Treatments 😀',
    exhibitionProductFilter: 'Exhibition Treatments 😀',
    feedbackAuthRequestSuccess:
      'Please enter the 6-digit authentication number sent to your phone.',
    feedbackAuthRequestSuccessEmail:
      'Please enter the 6-digit authentication number sent to your email.',
    noReservationHistories: 'No reservations registered',
    noProducts: 'No treatments registered',
    reservationCustomerInfo: 'Reservation Information',
    reservationCustomerName: 'Reservation Name',
    reservationCustomerPhone: 'Contact Number',

    needConsultation: 'need consultation',
    birth: 'Date of Birth',
    birthInputGuide: 'Please enter your date of birth in YYYY-MM-DD format.',
    invalidBirthInputMessage: 'Please enter a valid date of birth.',
  },
  [LanguageCode.ja]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: '今すぐ予約（初回）',
    drpetitFollowUpVisitBooking: '今すぐ予約（再診）',
    logout: '認証解除',
    /**
     * Custom pages
     */
    nbomLandingTitle1: 'Glowing Skin,\nBlooming Beauty',
    nbomLandingTitle2: 'with MeSOnBOM',
    nbomLandingReservationDescription: 'Quick & Easy\nreservation.',
    /**
     * AI 코디 상담 요청
     */
    completeChatRequest:
      '受付が完了しました。\n担当者が確認後、できるだけ早くご返信いたします。',
    chatRequestWelcomeTitle: 'こんにちは！\n担当者に接続が必要ですか？',
    chatRequestWelcomeDesc:
      '病院の営業時間内に順次確認し、迅速にご返信いたします。',
    connectChatRequired: 'はい、接続が必要です',
    connectChatLater: 'いいえ、後でまた行います',

    /**
     * 리뷰
     */
    reviewCommentPlaceholder: '追加のご意見を入力してください',
    visitDate: '訪問日',
    reviewTitleService: '全般的なサービスの満足度はいかがでしたか？',
    reviewTitleTherapist: 'セラピストに満足しましたか？',
    reviewTitleDoctor: '先生は親切でしたか？',
    reviewTitleTreatment: '受けた施術に満足しましたか？',
    reviewTitleConsultant: 'コンサルタントは親切でしたか？',
    reviewTitleVisit: '全体的な訪問経験は満足ですか？',
    reviewTitleReturn: '全体的な退院経験は満足ですか？',
    reviewTitleContent: 'その他のご意見をお書きください',
    addReview: 'レビュー登録',
    completeReview: 'レビュー登録完了',
    completeReviewDescription:
      '{partnerName}にご来院いただき、ありがとうございます！\nご記入いただいたレビューをもとに\nより良いサービスを提供いたします。',
    writeAnonymously: '匿名で作成する',

    /**
     * 예약
     */
    noAvailableReservationTime: '予約可能な時間がありません。',
    unavailableTreatment: '予約不可の施術。',
    productOptionUpdatedNotice:
      '施術情報が変更されたため反映しました。内容をご確認のうえ、もう一度お進みください。',
    productOptionRemovedNotice: '予約できない施術を除外しました。',
    noAvailableReservationTimeDesc1:
      '指定した日には担当医が不在のため、予約できません。',
    noAvailableReservationTimeDesc2:
      '別の日を選ぶか、施術内容を調整してください。',
    productPriceNoticeDesc: '料金は参考用で、支払いは現地で行います。',
    treatmentReservationTag: '施術予約',
    consultingReservationTag: '相談予約',
    noRecentReservation: '最近の予約履歴はありません。',
    selectRecentReservationTitle: '最近の予約日を選択してください',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: '診療分野',
    selectedConsultingCategoryTitle: '追加相談',
    extraConsultingCategoryTitle: '追加可能な相談',
    extraConsultingCategoryTitlePostFix: '(複数選択可能)',
    primaryTreatmentCategoryPlaceholder: '第1診療分野',
    secondaryTreatmentCategoryPlaceholder: '第2診療分野',
    revisitReservationButtonTitle: '最近の診療再予約',
    treatmentReservationButtonTitle: '施術予約',
    consultingReservationButtonTitle: '相談予約',
    selectReservationMenu: '予約メニューを選択してください。',
    bookAppointment: '診療予約',
    thisMonthEvent: '今月のイベント',
    reservationAvailable: '予約可',
    reservationUnavailable: '予約不可',
    reservedProducts: '{productOptionName} 他 {n}件',
    noExpectPrice: '相談後に案内',
    reservationCancelPolicy1:
      '予約申請状態では、予約日時の変更および予約キャンセルが可能です。',
    reservationCancelPolicy2:
      '予約確定状態では、予約日時の変更および予約キャンセルはできません。やむを得ず訪問できない場合は、直接チャンネルトーク1:1相談または電話相談で予約をキャンセルしてください。',
    filterCategoriesAndEvents: 'カテゴリーおよびイベント',
    reservationStatusCancel: '予約キャンセル',
    reservationStatusRequest: '予約申請',
    reservationStatusConfirm: '予約確定',
    completeReservationCancel: '予約がキャンセルされました',
    completeEditReservationDate: '予約日が変更されました',
    confirmCancelReservation: '予約をキャンセルしますか？',
    confirmEditReservation: '選択した日に予約を変更しますか？',
    cancel: 'キャンセル',
    cancelReservation: '予約キャンセル',
    editReservation: '予約変更',
    searchPlaceholder: '検索ワードを入力してください',
    event: 'イベント',
    aiCodiRecommend: 'AI相談員のおすすめ',
    allTermsAgreement: '全ての条項に同意',
    termsEssential: '[必須]',
    termsOptional: '[任意]',
    allTreatment: '全ての施術',
    reservationLandingGreeting: 'こんにちは、{partnerName}です',
    reservationLandingDescription: '以下のメニューから予約をお手伝いします。',
    treatmentSelectReservation: '施術選択予約',
    visitConsultingReservation: '訪問相談予約',
    reservationHistoriesButton: '予約確認',
    makeReservation: '予約する',
    reservationDetail: '予約詳細',
    normalBusiness: '通常診療',
    selectTime: '時間を選択',
    selectDate: '訪問日を選択',
    selectTreatmentCategory: 'Select Treatment Category',
    selectTreatmentCategoryDesc: '相談したい分野を選んでください。',
    requestReservation: '予約申請',
    reservationVerifyTitle: '以下の予約をご確認ください。',
    reservationRequestNotice: 'ご予約は承認後に確定いたします。',
    reservationDate: '予約日',
    reservationDateTime: '予約日時',
    expectedPaymentPrice: '支払額',
    expectedPrice: '予想価格',
    consultingMemo: '相談申請内容',
    noConsultingMemo: 'なし',
    selectedTreatments: '選択施術',
    requestAuth: '認証申請',
    consultingMemoPlaceholder:
      '事前にご相談内容を教えていただくと、よりスムーズに対応できます。',
    namePlaceholder: 'お名前を入力してください',
    firstNamePlaceholder: '名 (めい)',
    lastNamePlaceHolder: '姓 (せい)',
    passportNameGuideDescription:
      'パスポートに記載されている英字氏名を、スペース（空白）も含めて正確に入力してください。',
    phonePlaceholder: '連絡先を入力してください',
    emailPlaceholder: 'メールアドレスを入力してください',
    authNoPlaceholder: '認証番号を入力してください',
    resendAuth: '再送信',
    resendAuthTimer: '再送信 ({0}秒)',
    validationGuide: '必須情報を正しく入力してください。',
    unitEA: '個',
    confirm: '確認',
    priceUnit: '円',
    completeReservation: '予約申請完了',
    completeReservationDesc: '病院が確認後、予約確定のご連絡をいたします！',
    confirmReservation: 'ご予約が完了しましたよ！',
    confirmReservationDesc:
      '予約時間に病院にお越しくださいね。お待ちしています！😊',
    includeVAT: '（消費税含む）',
    excludeVAT: '（消費税別途）',
    next: '次へ',
    reservationHistories: '予約リスト',
    consultingReservation: '訪問/相談',
    unitReservationProductEA: '件',
    all: 'すべて',
    aiCodeRecommendProductFilter: 'おすすめ施術 😀',
    exhibitionProductFilter: '企画展施術 😀',
    feedbackAuthRequestSuccess:
      '携帯電話に送信された6桁の認証番号を入力してください。',
    feedbackAuthRequestSuccessEmail:
      'メールに送信された認証番号6桁を入力してください。',
    noReservationHistories: '登録された予約がありません',
    noProducts: '登録された施術がありません',
    reservationCustomerInfo: '予約者情報',
    reservationCustomerName: '予約者名',
    reservationCustomerPhone: '連絡先',

    needConsultation: '相談が必要',
    birth: '生年月日',
    birthInputGuide: '生年月日は YYYY-MM-DD 形式で入力してください。',
    invalidBirthInputMessage: '	有効な生年月日を入力してください。',
  },
  [LanguageCode.zh]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: '预约疗程 (初诊)',
    drpetitFollowUpVisitBooking: '预约疗程 (复诊)',
    logout: '取消认证',
    /**
     * Custom pages
     */
    nbomLandingTitle1: '焕亮美肌，绽放美丽',
    nbomLandingTitle2: '美塑颜春医院',
    nbomLandingReservationDescription: '迅速便捷的预约方式',
    /**
     * AI 코디 상담 요청
     */
    completeChatRequest: '接收已完成。\n我们会在确认后尽快回复您。',
    chatRequestWelcomeTitle: '您好！\n需要连接到负责人吗？',
    chatRequestWelcomeDesc: '我们将在医院营业时间内逐步确认并尽快回复。',
    connectChatRequired: '是的，我需要连接',
    connectChatLater: '不，我稍后再进行',

    /**
     * 리뷰
     */
    noExpectPrice: '咨询后告知',
    visitDate: '访问日期',
    reviewTitleService: '整体服务满意度如何？',
    reviewTitleTherapist: '对管理师满意吗？',
    reviewTitleDoctor: '医生友好吗？',
    reviewTitleTreatment: '对收到的治疗满意吗？',
    reviewTitleConsultant: '咨询员友好吗？',
    reviewTitleVisit: '对整体访问体验满意吗？',
    reviewTitleReturn: '对整体出院体验满意吗？',
    reviewTitleContent: '请填写其他意见',
    addReview: '添加评论',
    completeReview: '评论完成',
    completeReviewDescription:
      '感谢您访问{partnerName}！\n我们将根据您的评论\n提供更好的服务。',
    writeAnonymously: '以匿名方式撰写',
    reviewCommentPlaceholder: '请随意撰写您的意见。',

    /**
     * 예약
     */
    noAvailableReservationTime: '没有可预约的时间。',
    unavailableTreatment: '无法预约的治疗项目。',
    productOptionUpdatedNotice: '治疗信息已变更并已更新，请确认后再继续。',
    productOptionRemovedNotice: '已移除无法预约的治疗项目。',
    noAvailableReservationTimeDesc1: '该日期医生不在，无法预约。',
    noAvailableReservationTimeDesc2: '请更换日期或调整所选治疗项目。',
    productPriceNoticeDesc: '价格仅供参考，支付需在现场进行。',
    treatmentReservationTag: '治疗预约',
    consultingReservationTag: '咨询预约',
    noRecentReservation: '没有最近的预约记录。',
    selectRecentReservationTitle: '请选择最近的预约日期',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: '诊疗领域',
    selectedConsultingCategoryTitle: '追加咨询',
    extraConsultingCategoryTitle: '可添加的咨询',
    extraConsultingCategoryTitlePostFix: '(可多选)',
    primaryTreatmentCategoryPlaceholder: '第一诊疗领域',
    secondaryTreatmentCategoryPlaceholder: '诊疗领域差异',
    revisitReservationButtonTitle: '最近的诊疗重新预约',
    treatmentReservationButtonTitle: '治疗预约',
    consultingReservationButtonTitle: '预约咨询',
    selectReservationMenu: '请选择预约菜单。',
    bookAppointment: '预约就诊',
    thisMonthEvent: '本月活动',
    reservationAvailable: '可预约',
    reservationUnavailable: '不可预约',
    reservedProducts: '{productOptionName} 外 {n}件',
    reservationCancelPolicy1:
      '在预约申请状态下，可以更改预约日期和时间或取消预约。',
    reservationCancelPolicy2:
      '预约确认状态后，无法更改预约日期和时间或取消预约。如果不能到访，请通过直接频道谈话1:1咨询或电话咨询取消预约。',
    filterCategoriesAndEvents: '类别及活动',
    reservationStatusCancel: '取消预约',
    reservationStatusRequest: '预约申请',
    reservationStatusConfirm: '预约确认',
    completeReservationCancel: '预约已取消',
    completeEditReservationDate: '预约日期已更改',
    confirmCancelReservation: '确定取消预约吗？',
    confirmEditReservation: '确定将预约更改为选择的日期吗？',
    cancel: '取消',
    cancelReservation: '取消预约',
    editReservation: '更改预约',
    searchPlaceholder: '请输入搜索词',
    event: '活动',
    aiCodiRecommend: 'AI顾问推荐',
    allTermsAgreement: '同意所有条款',
    termsEssential: '[必需]',
    termsOptional: '[可选]',
    allTreatment: '所有治疗',
    reservationLandingGreeting: '您好，这里是{partnerName}',
    reservationLandingDescription: '我们将通过以下菜单为您提供预约帮助。',
    treatmentSelectReservation: '选择治疗预约',
    visitConsultingReservation: '访问咨询预约',
    reservationHistoriesButton: '预约管理',
    makeReservation: '进行预约',
    reservationDetail: '预约详情',
    normalBusiness: '正常诊疗',
    selectTime: '选择时间',
    selectDate: '选择访问日期',
    selectTreatmentCategory: 'Select Treatment Category',
    selectTreatmentCategoryDesc: '请选择您想咨询的领域。',
    requestReservation: '申请预约',
    reservationVerifyTitle: '请确认以下预约资料',
    reservationRequestNotice: '您的预约将在审核通过后确认',
    reservationDate: '预约日期',
    reservationDateTime: '[预约资料]\n预约日期及时间',
    expectedPaymentPrice: '支付金额',
    expectedPrice: '预计金额',
    consultingMemo: '咨询申请内容',
    noConsultingMemo: '无',
    selectedTreatments: '选择的治疗',
    requestAuth: '请求认证',
    consultingMemoPlaceholder:
      '如果您事先填写肌肤问题，可以更快速地进行咨询。如有同行者，请一并填写对方的英文姓名！',
    namePlaceholder: '请输入您的姓名',
    firstNamePlaceholder: '名',
    lastNamePlaceHolder: '姓',
    passportNameGuideDescription:
      '烦请您按照护照上的英文拼写如实填写您的姓名，感谢您的配合。',
    phonePlaceholder: '请输入您的联系方式',
    emailPlaceholder: '输入您的电子邮箱',
    authNoPlaceholder: '请输入认证号码',
    resendAuth: '重新发送',
    resendAuthTimer: '重新发送 ({0}秒)',
    validationGuide: '请正确输入所需信息。',
    unitEA: '个',
    confirm: '确认',
    priceUnit: '元',
    completeReservation: '预约确认后，我们会通知您！',
    completeReservationDesc: '请按预约时间来医院就行，祝您一切顺利！😊',
    confirmReservation: 'ご予約が完了しましたよ！',
    confirmReservationDesc:
      '予約時間に病院にお越しくださいね。お待ちしています！😊',
    includeVAT: '（含增值税）',
    excludeVAT: '（不含增值税）',
    next: '下一步',
    reservationHistories: '预约列表',
    consultingReservation: '访问/咨询',
    unitReservationProductEA: '件',
    all: '全部',
    aiCodeRecommendProductFilter: '推荐治疗 😀',
    exhibitionProductFilter: '展览治疗 😀',
    feedbackAuthRequestSuccess: '请输入发送到您手机上的6位认证号码。',
    feedbackAuthRequestSuccessEmail: '请输入发送到您邮箱的6位验证码。',
    noReservationHistories: '没有注册的预约',
    noProducts: '没有注册的治疗信息',
    reservationCustomerInfo: '预约者信息',
    reservationCustomerName: '预约者姓名',
    reservationCustomerPhone: '联系方式',

    needConsultation: '需要咨询',
    birth: '出生日期',
    birthInputGuide: '请按照 YYYY-MM-DD 格式输入出生日期。',
    invalidBirthInputMessage: '请输入有效的出生日期。',
  },
  [LanguageCode.zh_tw]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: '預約療程 (初診)',
    drpetitFollowUpVisitBooking: '預約療程 (復診)',
    logout: '取消認證',
    /**
     * Custom pages
     */
    nbomLandingTitle1: '煥亮美肌，綻放美麗',
    nbomLandingTitle2: '顏春醫院',
    nbomLandingReservationDescription: '迅速便捷的預約方式',
    /**
     * AI 코디 상담 요청
     */
    completeChatRequest: '接收已完成。\n我們會在確認後儘快回覆您。',
    chatRequestWelcomeTitle: '您好！\n需要連接到負責人嗎？',
    chatRequestWelcomeDesc: '我們將在醫院營業時間內逐步確認並儘快回覆。',
    connectChatRequired: '是的，我需要連接',
    connectChatLater: '不，我稍後再進行',

    /**
     * 리뷰
     */
    noExpectPrice: '諮詢後告知',
    visitDate: '訪問日期',
    reviewTitleService: '整體服務滿意度如何？',
    reviewTitleTherapist: '對管理師滿意嗎？',
    reviewTitleDoctor: '醫生友好嗎？',
    reviewTitleTreatment: '對收到的治療滿意嗎？',
    reviewTitleConsultant: '諮詢員友好嗎？',
    reviewTitleVisit: '對整體訪問體驗滿意嗎？',
    reviewTitleReturn: '對整體出院體驗滿意嗎？',
    reviewTitleContent: '請填寫其他意見',
    addReview: '添加評論',
    completeReview: '評論完成',
    completeReviewDescription:
      '感謝您訪問{partnerName}！\n我們將根據您的評論\n提供更好的服務。',
    writeAnonymously: '以匿名方式撰寫',
    reviewCommentPlaceholder: '請隨意撰寫您的意見。',

    /**
     * 예약
     */
    noAvailableReservationTime: '沒有可預約的時間。',
    unavailableTreatment: '無法預約的治療項目。',
    productOptionUpdatedNotice: '療程資訊已變更並已更新，請確認後再繼續。',
    productOptionRemovedNotice: '已移除無法預約的療程項目。',
    noAvailableReservationTimeDesc1: '該日期醫生不在，無法預約。',
    noAvailableReservationTimeDesc2: '請更換日期或調整所選治療項目。',
    productPriceNoticeDesc: '價格僅供參考，支付需在現場進行。',
    treatmentReservationTag: '治療預約',
    consultingReservationTag: '諮詢預約',
    noRecentReservation: '沒有最近的預約記錄。',
    selectRecentReservationTitle: '請選擇最近的預約日期',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: '診療領域',
    selectedConsultingCategoryTitle: '追加諮詢',
    extraConsultingCategoryTitle: '可添加的諮詢',
    extraConsultingCategoryTitlePostFix: '(可多選)',
    primaryTreatmentCategoryPlaceholder: '第一診療領域',
    secondaryTreatmentCategoryPlaceholder: '診療領域差異',
    revisitReservationButtonTitle: '最近的診療重新預約',
    treatmentReservationButtonTitle: '治療預約',
    consultingReservationButtonTitle: '預約諮詢',
    selectReservationMenu: '請選擇預約菜單。',
    bookAppointment: '預約就診',
    thisMonthEvent: '本月活動',
    reservationAvailable: '可預約',
    reservationUnavailable: '不可預約',
    reservedProducts: '{productOptionName} 外 {n}件',
    reservationCancelPolicy1:
      '在預約申請狀態下，可以更改預約日期和時間或取消預約。',
    reservationCancelPolicy2:
      '預約確認狀態後，無法更改預約日期和時間或取消預約。如果不能到訪，請通過直接頻道談話1:1諮詢或電話諮詢取消預約。',
    filterCategoriesAndEvents: '類別及活動',
    reservationStatusCancel: '取消預約',
    reservationStatusRequest: '預約申請',
    reservationStatusConfirm: '預約確認',
    completeReservationCancel: '預約已取消',
    completeEditReservationDate: '預約日期已更改',
    confirmCancelReservation: '確定取消預約嗎？',
    confirmEditReservation: '確定將預約更改為選擇的日期嗎？',
    cancel: '取消',
    cancelReservation: '取消預約',
    editReservation: '更改預約',
    searchPlaceholder: '請輸入搜索詞',
    event: '活動',
    aiCodiRecommend: 'AI顧問推薦',
    allTermsAgreement: '同意所有條款',
    termsEssential: '[必需]',
    termsOptional: '[可選]',
    allTreatment: '所有治療',
    reservationLandingGreeting: '您好，這裡是{partnerName}',
    reservationLandingDescription: '我們將通過以下菜單為您提供預約幫助。',
    treatmentSelectReservation: '選擇治療預約',
    visitConsultingReservation: '訪問諮詢預約',
    reservationHistoriesButton: '預約管理',
    makeReservation: '進行預約',
    reservationDetail: '預約詳情',
    normalBusiness: '正常診療',
    selectTime: '選擇時間',
    selectDate: '選擇訪問日期',
    selectTreatmentCategory: 'Select Treatment Category',
    selectTreatmentCategoryDesc: '請選擇您想諮詢的領域。',
    requestReservation: '申請預約',
    reservationVerifyTitle: '請確認以下預約資料',
    reservationRequestNotice: '您的預約將在審核通過後確認',
    reservationDate: '預約日期',
    reservationDateTime: '[預約資料]\n預約日期及時間',
    expectedPaymentPrice: '支付金額',
    expectedPrice: '預計金額',
    consultingMemo: '諮詢申請內容',
    noConsultingMemo: '無',
    selectedTreatments: '選擇的治療',
    requestAuth: '請求認證',
    consultingMemoPlaceholder:
      '如果您事先填寫肌膚問題，可以更快速地進行諮詢。如有同行者，請一併填寫對方的英文姓名!',
    namePlaceholder: '請輸入您的姓名',
    firstNamePlaceholder: '名',
    lastNamePlaceHolder: '姓',
    passportNameGuideDescription:
      '請依照護照上顯示的英文姓名，包含空格正確輸入。',
    phonePlaceholder: '請輸入您的聯繫方式',
    emailPlaceholder: '輸入您的電子郵箱',
    authNoPlaceholder: '請輸入認證號碼',
    resendAuth: '重新發送',
    resendAuthTimer: '重新發送 ({0}秒)',
    validationGuide: '請正確輸入所需信息。',
    unitEA: '個',
    confirm: '確認',
    priceUnit: '元',
    completeReservation: '預約確認後，我們會通知您！',
    completeReservationDesc: '請按預約時間來醫院就行，祝您一切順利！😊',
    confirmReservation: 'ご予約が完了しましたよ！',
    confirmReservationDesc:
      '予約時間に病院にお越しくださいね。お待ちしています！😊',
    includeVAT: '（含增值稅）',
    excludeVAT: '（不含增值稅）',
    next: '下一步',
    reservationHistories: '預約列表',
    consultingReservation: '訪問/諮詢',
    unitReservationProductEA: '件',
    all: '全部',
    aiCodeRecommendProductFilter: '推薦治療 😀',
    exhibitionProductFilter: '展覽治療 😀',
    feedbackAuthRequestSuccess: '請輸入發送到您手機上的6位認證號碼。',
    feedbackAuthRequestSuccessEmail: '請輸入發送到您郵箱的6位驗證碼。',
    noReservationHistories: '沒有註冊的預約',
    noProducts: '沒有註冊的治療信息',
    reservationCustomerInfo: '預約者信息',
    reservationCustomerName: '預約者姓名',
    reservationCustomerPhone: '聯繫方式',

    needConsultation: '需要諮詢',
    birth: '出生日期',
    birthInputGuide: '請按照 YYYY-MM-DD 格式輸入出生日期。',
    invalidBirthInputMessage: '請輸入有效的出生日期。',
  },
  [LanguageCode.ms]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: 'Tempah Rawatan (Kunjungan Pertama)',
    drpetitFollowUpVisitBooking: 'Tempah Rawatan (Kunjungan Susulan)',
    logout: 'Log Keluar',
    /**
     * Custom pages
     */
    nbomLandingTitle1: 'Tempat kecantikan anda mekar,',
    nbomLandingTitle2: 'with MeSOnBOM',
    nbomLandingReservationDescription:
      'Tempah dengan pantas\ntanpa perlu menunggu.',

    /**
     * AI 코디 상담요청
     */
    completeChatRequest:
      'Permohonan anda telah diterima.\nKami akan membalas secepat mungkin selepas semakan oleh kakitangan.',
    chatRequestWelcomeTitle:
      'Helo, pelanggan yang dihormati!\nAdakah anda perlu dihubungkan dengan kakitangan?',
    chatRequestWelcomeDesc:
      'Sambungan kepada kakitangan akan disemak dengan teliti dalam waktu operasi klinik dan kami akan membalas dengan segera.',
    connectChatRequired: 'Ya, saya perlu dihubungkan',
    connectChatLater: 'Tidak, saya akan cuba semula nanti',

    /**
     * 리뷰 질문
     */
    reviewCommentPlaceholder: 'Sila masukkan pendapat anda dengan bebas',
    visitDate: 'Tarikh Lawatan',
    reviewTitleService:
      'Sejauh manakah anda berpuas hati dengan perkhidmatan secara keseluruhan?',
    reviewTitleTherapist: 'Adakah anda berpuas hati dengan ahli terapi?',
    reviewTitleDoctor: 'Adakah doktor bersikap mesra?',
    reviewTitleTreatment:
      'Adakah anda berpuas hati dengan rawatan yang diterima?',
    reviewTitleConsultant: 'Adakah kakitangan konsultasi bersikap mesra?',
    reviewTitleVisit:
      'Adakah anda berpuas hati dengan pengalaman lawatan secara keseluruhan?',
    reviewTitleReturn:
      'Adakah anda berpuas hati dengan pengalaman keluar klinik secara keseluruhan?',
    reviewTitleContent: 'Sila tulis sebarang pendapat tambahan',
    addReview: 'Hantar Ulasan',
    completeReview: 'Ulasan Selesai',
    completeReviewDescription:
      'Terima kasih kerana melawat {partnerName}!\nKami akan menggunakan maklum balas anda untuk menambah baik perkhidmatan kami.',

    /**
     * 예약
     */
    noAvailableReservationTime: 'Tiada masa tempahan yang tersedia',
    unavailableTreatment: 'Rawatan tidak tersedia',
    productOptionUpdatedNotice:
      'Maklumat rawatan telah berubah dan diterapkan. Sila semak dan cuba semula.',
    productOptionRemovedNotice:
      'Rawatan yang tidak boleh ditempah telah dialih keluar daripada senarai.',
    noAvailableReservationTimeDesc1:
      'Doktor yang bertugas tidak hadir pada tarikh ini, jadi tempahan tidak dapat dibuat.',
    noAvailableReservationTimeDesc2:
      'Sila pilih tarikh lain atau laraskan rawatan anda.',
    productPriceNoticeDesc:
      'Harga hanya untuk rujukan; pembayaran dibuat di klinik.',
    treatmentReservationTag: 'Tempahan Rawatan',
    consultingReservationTag: 'Tempahan Konsultasi',
    noRecentReservation: 'Tiada rekod rawatan terkini',
    selectRecentReservationTitle: 'Sila pilih tarikh rawatan terkini',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: 'Bidang Perubatan',
    selectedConsultingCategoryTitle: 'Konsultasi Tambahan',
    extraConsultingCategoryTitle: 'Konsultasi Tersedia',
    extraConsultingCategoryTitlePostFix: '(Boleh pilih lebih daripada satu)',
    primaryTreatmentCategoryPlaceholder: 'Bidang Perubatan (Utama)',
    secondaryTreatmentCategoryPlaceholder: 'Bidang Perubatan (Kedua)',
    revisitReservationButtonTitle: 'Tempah Semula Rawatan Terkini',
    treatmentReservationButtonTitle: 'Tempah Rawatan',
    consultingReservationButtonTitle: 'Tempah Konsultasi',
    selectReservationMenu: 'Sila pilih menu tempahan',
    bookAppointment: 'Tempah Temujanji',
    thisMonthEvent: 'Acara Bulan Ini',
    reservationAvailable: 'Tersedia',
    reservationUnavailable: 'Tidak Tersedia',
    reservedProducts: '{productOptionName} dan {n} lagi',
    noExpectPrice: 'Maklumat selepas konsultasi',
    reservationCancelPolicy1:
      'Tarikh dan masa tempahan boleh diubah atau tempahan boleh dibatalkan selagi status masih Permohonan Tempahan.',
    reservationCancelPolicy2:
      'Selepas tempahan disahkan, tarikh dan masa tidak boleh diubah dan tempahan tidak boleh dibatalkan. Jika anda tidak dapat hadir, sila batalkan tempahan melalui konsultasi 1:1 terus di Channel Talk atau konsultasi telefon.',
    filterCategoriesAndEvents: 'Kategori dan Acara',
    reservationStatusCancel: 'Dibatalkan',
    reservationStatusRequest: 'Permohonan Tempahan',
    reservationStatusConfirm: 'Tempahan Disahkan',
    completeReservationCancel: 'Tempahan telah dibatalkan',
    completeEditReservationDate: 'Tarikh tempahan telah ditukar',
    confirmCancelReservation: 'Adakah anda ingin membatalkan tempahan?',
    confirmEditReservation:
      'Adakah anda mahu menukar tempahan kepada tarikh yang dipilih?',
    cancel: 'Batal',
    cancelReservation: 'Batal Tempahan',
    editReservation: 'Ubah Tempahan',
    searchPlaceholder: 'Sila masukkan kata carian',
    event: 'Acara',
    aiCodiRecommend: 'Cadangan Kaunselor AI',
    allTermsAgreement: 'Setuju kepada semua terma',
    termsEssential: '[Wajib]',
    termsOptional: '[Pilihan]',
    allTreatment: 'Semua Rawatan',
    reservationLandingGreeting: 'Helo 🙂\n{partnerName} di sini',
    reservationLandingDescription:
      'Kami akan membantu anda membuat tempahan melalui menu di bawah.',
    treatmentSelectReservation: 'Tempahan Pilihan Rawatan',
    visitConsultingReservation: 'Tempahan Semula / Konsultasi Lawatan',
    reservationHistoriesButton: 'Semak / Ubah / Batal Tempahan',
    makeReservation: 'Buat Tempahan',
    reservationDetail: 'Butiran Tempahan',
    normalBusiness: 'Operasi Biasa',
    selectTime: 'Pilih Masa',
    selectDate: 'Pilih Tarikh Lawatan',
    selectTreatmentCategory: 'Pilih Bidang Rawatan',
    selectTreatmentCategoryDesc: 'Sila pilih bidang rawatan yang dikehendaki',
    requestReservation: 'Mohon Tempahan',
    reservationVerifyTitle: 'Sila sahkan tempahan berikut',
    reservationRequestNotice:
      'Klinik akan menyemak dan mengesahkan tempahan anda.',
    reservationDate: 'Tarikh Tempahan',
    reservationDateTime: '[Maklumat tempahan]\nTarikh/Masa Tempahan',
    expectedPaymentPrice: 'Jumlah Bayaran',
    expectedPrice: 'Harga Jangkaan',
    consultingMemo: 'Butiran Permohonan Konsultasi',
    noConsultingMemo: 'Tiada',
    selectedTreatments: 'Rawatan Dipilih',
    requestAuth: 'Pengesahan',
    consultingMemoPlaceholder:
      'Nyatakan kebimbangan kulit anda terlebih dahulu supaya konsultasi dapat dilakukan dengan lebih pantas. Jika anda datang bersama seseorang, sila masukkan nama mereka juga!',
    namePlaceholder: 'Sila masukkan nama anda',
    firstNamePlaceholder: 'Sila masukkan nama pertama',
    lastNamePlaceHolder: 'Sila masukkan nama keluarga',
    passportNameGuideDescription:
      'Sila masukkan nama anda dalam huruf rumi tepat seperti yang tertera dalam pasport, termasuk jarak.',
    phonePlaceholder: 'Sila masukkan nombor telefon',
    emailPlaceholder: 'Sila masukkan emel anda',
    authNoPlaceholder: 'Sila masukkan nombor pengesahan',
    resendAuth: 'Hantar Semula',
    resendAuthTimer: 'Hantar Semula ({0}s)',
    validationGuide: 'Sila masukkan maklumat wajib dengan betul.',
    unitEA: 'unit',
    confirm: 'Sahkan',
    priceUnit: 'KRW',
    completeReservation: 'Mengesahkan Tempahan Anda',
    completeReservationDesc:
      'Kami akan memaklumkan anda apabila tempahan disahkan!',
    confirmReservation: 'Tempahan Selesai',
    confirmReservationDesc:
      'Sila hadir ke klinik mengikut masa tempahan. Kami menanti kedatangan anda! 😊',

    includeVAT: '(Termasuk VAT)',
    excludeVAT: '(Tidak termasuk VAT)',
    next: 'Seterusnya',
    reservationHistories: 'Senarai Tempahan',
    consultingReservation: 'Lawatan/Konsultasi',
    unitReservationProductEA: 'item',
    all: 'Semua',
    aiCodeRecommendProductFilter: 'Rawatan Disyorkan 😀',
    exhibitionProductFilter: 'Rawatan Pameran 😀',
    feedbackAuthRequestSuccess:
      'Sila masukkan nombor pengesahan 6 digit yang dihantar ke telefon bimbit anda.',
    feedbackAuthRequestSuccessEmail:
      'Sila masukkan nombor pengesahan 6 digit yang dihantar ke emel anda.',
    noReservationHistories: 'Tiada tempahan didaftarkan',
    noProducts: 'Tiada maklumat rawatan didaftarkan',
    reservationCustomerInfo: 'Maklumat Tempahan',
    reservationCustomerName: 'Nama Tempahan',
    reservationCustomerPhone: 'Nombor Telefon',

    needConsultation: 'Perlu konsultasi',
    writeAnonymously: 'Tulis secara tanpa nama',
    birth: 'Tarikh Lahir',
    birthInputGuide: 'Sila masukkan tarikh lahir anda',
    invalidBirthInputMessage: 'Sila masukkan tarikh lahir yang sah.',
  },
  [LanguageCode.th]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: 'จองการตรวจรักษา (ผู้ป่วยใหม่)',
    drpetitFollowUpVisitBooking: 'จองการตรวจรักษา (ผู้ป่วยเดิม)',
    logout: 'ยกเลิกการยืนยันตัวตน',
    /**
     * Custom pages
     */
    nbomLandingTitle1: 'สถานที่ที่ความงามของคุณเบ่งบาน,',
    nbomLandingTitle2: 'with MeSOnBOM',
    nbomLandingReservationDescription: 'จองได้อย่างรวดเร็ว\nโดยไม่ต้องรอคิว',

    /**
     * AI 코디 상담요청
     */
    completeChatRequest:
      'รับคำขอเรียบร้อยแล้ว\nเจ้าหน้าที่จะตรวจสอบและตอบกลับให้เร็วที่สุด',
    chatRequestWelcomeTitle:
      'ยินดีต้อนรับ!\nต้องการเชื่อมต่อกับเจ้าหน้าที่หรือไม่?',
    chatRequestWelcomeDesc:
      'การเชื่อมต่อกับเจ้าหน้าที่จะตรวจสอบตามลำดับในเวลาทำการของคลินิก และตอบกลับโดยเร็ว',
    connectChatRequired: 'ใช่ ต้องการเชื่อมต่อ',
    connectChatLater: 'ไม่ใช่ ไว้ทีหลัง',

    /**
     * 리뷰 질문
     */
    reviewCommentPlaceholder: 'กรุณากรอกความคิดเห็นของคุณได้อย่างอิสระ',
    visitDate: 'วันที่เข้ารับบริการ',
    reviewTitleService: 'คุณพอใจกับบริการโดยรวมแค่ไหน?',
    reviewTitleTherapist: 'คุณพอใจกับนักบำบัดหรือไม่?',
    reviewTitleDoctor: 'คุณหมอให้บริการด้วยความเป็นมิตรหรือไม่?',
    reviewTitleTreatment: 'คุณพอใจกับการรักษาที่ได้รับหรือไม่?',
    reviewTitleConsultant:
      'เจ้าหน้าที่ที่ปรึกษาให้บริการด้วยความเป็นมิตรหรือไม่?',
    reviewTitleVisit: 'คุณพอใจกับประสบการณ์การเข้ารับบริการโดยรวมหรือไม่?',
    reviewTitleReturn: 'คุณพอใจกับประสบการณ์โดยรวมก่อนกลับหรือไม่?',
    reviewTitleContent: 'กรุณาเขียนความคิดเห็นเพิ่มเติมอื่น ๆ',
    addReview: 'ลงรีวิว',
    completeReview: 'ลงรีวิวเรียบร้อยแล้ว',
    completeReviewDescription:
      'ขอบคุณที่เข้ารับบริการที่ {partnerName}!\nเราจะนำรีวิวของคุณไปพัฒนา\nบริการให้ดียิ่งขึ้น',

    /**
     * 예약
     */
    noAvailableReservationTime: 'ไม่มีเวลาที่สามารถจองได้',
    unavailableTreatment: 'การรักษาที่จองไม่ได้',
    productOptionUpdatedNotice:
      'ข้อมูลการรักษามีการเปลี่ยนแปลงและอัปเดตแล้ว กรุณาตรวจสอบแล้วดำเนินการอีกครั้ง',
    productOptionRemovedNotice: 'การรักษาที่ไม่สามารถจองได้ถูกนำออกแล้ว',
    noAvailableReservationTimeDesc1:
      'วันที่นี้ไม่สามารถจองได้ เนื่องจากคุณหมอที่รับผิดชอบไม่อยู่',
    noAvailableReservationTimeDesc2:
      'กรุณาเลือกวันอื่นหรือปรับการรักษาที่เลือก',
    productPriceNoticeDesc:
      'ราคาเป็นเพียงข้อมูลเท่านั้น การชำระเงินดำเนินการที่คลินิก',
    treatmentReservationTag: 'จองการรักษา',
    consultingReservationTag: 'จองการปรึกษา',
    noRecentReservation: 'ไม่มีประวัติการรักษาล่าสุด',
    selectRecentReservationTitle: 'กรุณาเลือกวันที่รับการรักษาล่าสุด',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: 'สาขาการรักษา',
    selectedConsultingCategoryTitle: 'การปรึกษาเพิ่มเติม',
    extraConsultingCategoryTitle: 'การปรึกษาเพิ่มเติมที่เลือกได้',
    extraConsultingCategoryTitlePostFix: '(เลือกได้หลายรายการ)',
    primaryTreatmentCategoryPlaceholder: 'สาขาการรักษา (ขั้นที่ 1)',
    secondaryTreatmentCategoryPlaceholder: 'สาขาการรักษา (ขั้นที่ 2)',
    revisitReservationButtonTitle: 'จองซ้ำจากการรักษาล่าสุด',
    treatmentReservationButtonTitle: 'จองการรักษา',
    consultingReservationButtonTitle: 'จองการปรึกษา',
    selectReservationMenu: 'กรุณาเลือกเมนูการจอง',
    bookAppointment: 'จองนัดตรวจรักษา',
    thisMonthEvent: 'กิจกรรมประจำเดือนนี้',
    reservationAvailable: 'จองได้',
    reservationUnavailable: 'จองไม่ได้',
    reservedProducts: '{productOptionName} และอีก {n} รายการ',
    noExpectPrice: 'แจ้งหลังการปรึกษา',
    reservationCancelPolicy1:
      'ในสถานะขอจอง สามารถเปลี่ยนวันและเวลาที่จอง หรือยกเลิกการจองได้',
    reservationCancelPolicy2:
      'เมื่อการจองได้รับการยืนยันแล้ว จะไม่สามารถเปลี่ยนวันและเวลาที่จอง หรือยกเลิกการจองได้ หากไม่สามารถเข้ารับบริการได้ กรุณายกเลิกการจองผ่านการปรึกษา 1:1 ทาง Channel Talk หรือการปรึกษาทางโทรศัพท์',
    filterCategoriesAndEvents: 'หมวดหมู่และกิจกรรม',
    reservationStatusCancel: 'ยกเลิกการจอง',
    reservationStatusRequest: 'ขอจอง',
    reservationStatusConfirm: 'ยืนยันการจองแล้ว',
    completeReservationCancel: 'ยกเลิกการจองเรียบร้อยแล้ว',
    completeEditReservationDate: 'เปลี่ยนวันที่จองเรียบร้อยแล้ว',
    confirmCancelReservation: 'ต้องการยกเลิกการจองใช่ไหม?',
    confirmEditReservation: 'ต้องการเปลี่ยนการจองเป็นวันที่เลือกใช่ไหม?',
    cancel: 'ยกเลิก',
    cancelReservation: 'ยกเลิกการจอง',
    editReservation: 'เปลี่ยนแปลงการจอง',
    searchPlaceholder: 'กรุณากรอกคำค้นหา',
    event: 'กิจกรรม',
    aiCodiRecommend: 'แนะนำโดย AI ที่ปรึกษา',
    allTermsAgreement: 'ยอมรับข้อกำหนดทั้งหมด',
    termsEssential: '[จำเป็น]',
    termsOptional: '[ไม่บังคับ]',
    allTreatment: 'การรักษาทั้งหมด',
    reservationLandingGreeting: 'สวัสดี🙂\nนี่คือ {partnerName}',
    reservationLandingDescription: 'เราจะช่วยดำเนินการจองผ่านเมนูด้านล่าง',
    treatmentSelectReservation: 'จองโดยเลือกการรักษา',
    visitConsultingReservation: 'จองการเข้าพบ/ปรึกษาสำหรับผู้ป่วยเดิม',
    reservationHistoriesButton: 'ตรวจสอบ / เปลี่ยนแปลง / ยกเลิกการจอง',
    makeReservation: 'ทำการจอง',
    reservationDetail: 'รายละเอียดการจอง',
    normalBusiness: 'เปิดให้บริการปกติ',
    selectTime: 'เลือกเวลา',
    selectDate: 'เลือกวันที่เข้ารับบริการ',
    selectTreatmentCategory: 'เลือกสาขาการรักษา',
    selectTreatmentCategoryDesc: 'กรุณาเลือกสาขาการรักษาที่ต้องการ',
    requestReservation: 'ขอจอง',
    reservationVerifyTitle: 'กรุณาตรวจสอบข้อมูลการจอง',
    reservationRequestNotice: 'คลินิกจะยืนยันการจองหลังจากตรวจสอบแล้ว',
    reservationDate: 'วันที่จอง',
    reservationDateTime: 'วันและเวลาที่จอง',
    expectedPaymentPrice: 'ยอดชำระเงิน',
    expectedPrice: 'ราคาโดยประมาณ',
    consultingMemo: 'รายละเอียดคำขอปรึกษา',
    noConsultingMemo: 'ไม่มี',
    selectedTreatments: 'การรักษาที่เลือก',
    requestAuth: 'ขอยืนยันตัวตน',
    consultingMemoPlaceholder:
      'หากแจ้งปัญหาผิวไว้ล่วงหน้า คุณจะได้รับการปรึกษาเร็วขึ้น\nหากมีผู้ติดตาม กรุณากรอกชื่อผู้ติดตามด้วย!',
    namePlaceholder: 'กรุณากรอกชื่อ-นามสกุล',
    firstNamePlaceholder: 'กรุณากรอกชื่อ',
    lastNamePlaceHolder: 'กรุณากรอกนามสกุล',
    passportNameGuideDescription:
      'กรุณากรอกชื่อภาษาอังกฤษให้ตรงกับที่ระบุในหนังสือเดินทาง รวมถึงการเว้นวรรค',
    phonePlaceholder: 'กรุณากรอกเบอร์โทรศัพท์',
    emailPlaceholder: 'กรุณากรอกอีเมล',
    authNoPlaceholder: 'กรุณากรอกรหัสยืนยัน',
    resendAuth: 'ส่งอีกครั้ง',
    resendAuthTimer: 'ส่งอีกครั้ง ({0} วินาที)',
    validationGuide: 'กรุณากรอกข้อมูลที่จำเป็นให้ถูกต้อง',
    unitEA: 'ชิ้น',
    confirm: 'ยืนยัน',
    priceUnit: 'วอน',
    completeReservation: 'ส่งคำขอจองเรียบร้อยแล้ว',
    completeReservationDesc: 'เราจะแจ้งให้ทราบเมื่อคลินิกยืนยันการจองแล้ว!',
    confirmReservation: 'จองเรียบร้อยแล้ว',
    confirmReservationDesc:
      'กรุณาเข้ารับบริการที่คลินิกตามเวลาที่จองไว้\nเรารอต้อนรับคุณอยู่นะ! 😊',

    includeVAT: '(รวม VAT)',
    excludeVAT: '(ไม่รวม VAT)',
    next: 'ถัดไป',
    reservationHistories: 'รายการจอง',
    consultingReservation: 'เข้าพบ/ปรึกษา',
    unitReservationProductEA: 'รายการ',
    all: 'ทั้งหมด',
    aiCodeRecommendProductFilter: 'การรักษาที่แนะนำ 😀',
    exhibitionProductFilter: 'การรักษาจากแคมเปญพิเศษ 😀',
    feedbackAuthRequestSuccess:
      'กรุณากรอกรหัสยืนยัน 6 หลักที่ส่งไปยังโทรศัพท์มือถือของคุณ',
    feedbackAuthRequestSuccessEmail:
      'กรุณากรอกรหัสยืนยัน 6 หลักที่ส่งไปยังอีเมลของคุณ',
    noReservationHistories: 'ไม่มีรายการจองที่ลงทะเบียนไว้',
    noProducts: 'ไม่มีข้อมูลการรักษาที่ลงทะเบียนไว้',
    reservationCustomerInfo: 'ข้อมูลผู้จอง',
    reservationCustomerName: 'ชื่อผู้จอง',
    reservationCustomerPhone: 'เบอร์โทรศัพท์',

    needConsultation: 'ต้องการการปรึกษา',
    writeAnonymously: 'เขียนแบบไม่ระบุตัวตน',
    birth: 'วันเกิด',
    birthInputGuide: 'กรุณากรอกวันเกิด',
    invalidBirthInputMessage: 'กรุณากรอกวันเกิดให้ถูกต้อง',
  },
  [LanguageCode.id]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: 'Reservasi Pemeriksaan (Pasien Baru)',
    drpetitFollowUpVisitBooking: 'Reservasi Pemeriksaan (Pasien Lama)',
    logout: 'Keluar',
    /**
     * Custom pages
     */
    nbomLandingTitle1: 'Kulit Cerah,\nKecantikan Bersemi',
    nbomLandingTitle2: 'with MeSOnBOM',
    nbomLandingReservationDescription:
      'Reservasi cepat & mudah\ntanpa perlu menunggu.',

    /**
     * AI 코디 상담요청
     */
    completeChatRequest:
      'Permintaan Anda telah diterima.\nKami akan memberikan jawaban secepat mungkin setelah ditinjau oleh staf.',
    chatRequestWelcomeTitle:
      'Halo!\nApakah Anda perlu terhubung dengan konsultan?',
    chatRequestWelcomeDesc:
      'Kami akan meninjau permintaan Anda selama jam operasional klinik dan memberikan jawaban secepat mungkin.',
    connectChatRequired: 'Ya, saya perlu terhubung',
    connectChatLater: 'Tidak, nanti saja',

    /**
     * 리뷰 질문
     */
    reviewCommentPlaceholder: 'Silakan tulis pendapat Anda dengan bebas',
    visitDate: 'Tanggal Kunjungan',
    reviewTitleService:
      'Seberapa puas Anda dengan pelayanan secara keseluruhan?',
    reviewTitleTherapist: 'Apakah Anda puas dengan terapis?',
    reviewTitleDoctor: 'Apakah dokter ramah?',
    reviewTitleTreatment: 'Apakah Anda puas dengan perawatan yang Anda terima?',
    reviewTitleConsultant: 'Apakah konsultan ramah?',
    reviewTitleVisit:
      'Apakah pengalaman kunjungan Anda secara keseluruhan memuaskan?',
    reviewTitleReturn:
      'Apakah pengalaman Anda saat keluar klinik secara keseluruhan memuaskan?',
    reviewTitleContent: 'Silakan tulis pendapat tambahan lainnya',
    addReview: 'Kirim Ulasan',
    completeReview: 'Ulasan Terkirim',
    completeReviewDescription:
      'Terima kasih telah berkunjung ke {partnerName}!\nKami akan menggunakan masukan Anda untuk meningkatkan layanan kami.',

    /**
     * 예약
     */
    noAvailableReservationTime: 'Tidak ada waktu reservasi yang tersedia',
    unavailableTreatment: 'Perawatan tidak tersedia',
    productOptionUpdatedNotice:
      'Informasi perawatan telah berubah dan sudah diperbarui. Silakan periksa kembali lalu coba lagi.',
    productOptionRemovedNotice:
      'Perawatan yang tidak bisa direservasi telah dikeluarkan dari daftar.',
    noAvailableReservationTimeDesc1:
      'Dokter yang bertugas tidak tersedia pada tanggal ini, sehingga reservasi sulit dilakukan.',
    noAvailableReservationTimeDesc2:
      'Silakan pilih tanggal lain atau sesuaikan perawatan Anda.',
    productPriceNoticeDesc:
      'Harga hanya untuk informasi; pembayaran dilakukan di klinik.',
    treatmentReservationTag: 'Reservasi Perawatan',
    consultingReservationTag: 'Reservasi Konsultasi',
    noRecentReservation: 'Tidak ada riwayat kunjungan terakhir',
    selectRecentReservationTitle: 'Silakan pilih tanggal kunjungan terakhir',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: 'Bidang Medis',
    selectedConsultingCategoryTitle: 'Konsultasi Tambahan',
    extraConsultingCategoryTitle: 'Konsultasi yang Tersedia',
    extraConsultingCategoryTitlePostFix: '(Dapat memilih lebih dari satu)',
    primaryTreatmentCategoryPlaceholder: 'Bidang Medis (Utama)',
    secondaryTreatmentCategoryPlaceholder: 'Bidang Medis (Sekunder)',
    revisitReservationButtonTitle: 'Reservasi Ulang Kunjungan Terakhir',
    treatmentReservationButtonTitle: 'Reservasi Perawatan',
    consultingReservationButtonTitle: 'Reservasi Konsultasi',
    selectReservationMenu: 'Silakan pilih menu reservasi',
    bookAppointment: 'Reservasi Pemeriksaan',
    thisMonthEvent: 'Event Bulan Ini',
    reservationAvailable: 'Tersedia',
    reservationUnavailable: 'Tidak Tersedia',
    reservedProducts: '{productOptionName} dan {n} lainnya',
    noExpectPrice: 'Informasi setelah konsultasi',
    reservationCancelPolicy1:
      'Tanggal dan waktu reservasi dapat diubah atau reservasi dapat dibatalkan selama status permintaan reservasi.',
    reservationCancelPolicy2:
      'Setelah reservasi dikonfirmasi, tanggal dan waktu tidak dapat diubah dan reservasi tidak dapat dibatalkan. Jika Anda tidak dapat berkunjung, silakan batalkan reservasi melalui konsultasi langsung 1:1 di Channel Talk atau konsultasi telepon.',
    filterCategoriesAndEvents: 'Kategori dan Event',
    reservationStatusCancel: 'Dibatalkan',
    reservationStatusRequest: 'Permintaan Reservasi',
    reservationStatusConfirm: 'Reservasi Dikonfirmasi',
    completeReservationCancel: 'Reservasi telah dibatalkan',
    completeEditReservationDate: 'Tanggal reservasi telah diubah',
    confirmCancelReservation: 'Apakah Anda ingin membatalkan reservasi?',
    confirmEditReservation:
      'Apakah Anda ingin mengubah reservasi ke tanggal yang dipilih?',
    cancel: 'Batal',
    cancelReservation: 'Batalkan Reservasi',
    editReservation: 'Ubah Reservasi',
    searchPlaceholder: 'Silakan masukkan kata kunci pencarian',
    event: 'Event',
    aiCodiRecommend: 'Rekomendasi Konsultan AI',
    allTermsAgreement: 'Setujui semua ketentuan',
    termsEssential: '[Wajib]',
    termsOptional: '[Opsional]',
    allTreatment: 'Semua Perawatan',
    reservationLandingGreeting: 'Halo, ini {partnerName}',
    reservationLandingDescription:
      'Kami akan membantu Anda melakukan reservasi melalui menu di bawah ini.',
    treatmentSelectReservation: 'Reservasi Pilih Perawatan',
    visitConsultingReservation: 'Reservasi Kunjungan / Konsultasi',
    reservationHistoriesButton: 'Cek / Ubah / Batalkan Reservasi',
    makeReservation: 'Reservasi',
    reservationDetail: 'Detail Reservasi',
    normalBusiness: 'Praktik Normal',
    selectTime: 'Pilih Waktu',
    selectDate: 'Pilih Tanggal Kunjungan',
    selectTreatmentCategory: 'Pilih Bidang Medis',
    selectTreatmentCategoryDesc: 'Silakan pilih bidang medis yang diinginkan',
    requestReservation: 'Ajukan Reservasi',
    reservationVerifyTitle: 'Silakan periksa informasi reservasi',
    reservationRequestNotice:
      'Reservasi akan dikonfirmasi setelah diperiksa oleh klinik.',
    reservationDate: 'Tanggal Reservasi',
    reservationDateTime: '[Info Reservasi]\nTanggal/Waktu Reservasi',
    expectedPaymentPrice: 'Jumlah Pembayaran',
    expectedPrice: 'Perkiraan Harga',
    consultingMemo: 'Detail Permintaan Konsultasi',
    noConsultingMemo: 'Tidak ada',
    selectedTreatments: 'Perawatan Terpilih',
    requestAuth: 'Verifikasi',
    consultingMemoPlaceholder:
      'Jika Anda menuliskan keluhan kulit terlebih dahulu, konsultasi dapat berjalan lebih cepat. Jika ada pendamping, mohon tuliskan juga nama pendamping Anda!',
    namePlaceholder: 'Masukkan nama Anda',
    firstNamePlaceholder: 'Masukkan nama depan Anda',
    lastNamePlaceHolder: 'Masukkan nama belakang Anda',
    passportNameGuideDescription:
      'Masukkan nama Anda dalam huruf Latin persis seperti yang tertera di paspor, termasuk spasi.',
    phonePlaceholder: 'Masukkan nomor telepon Anda',
    emailPlaceholder: 'Masukkan email Anda',
    authNoPlaceholder: 'Masukkan kode verifikasi',
    resendAuth: 'Kirim Ulang',
    resendAuthTimer: 'Kirim ulang ({0} dtk)',
    validationGuide: 'Silakan isi data wajib dengan benar.',
    unitEA: 'buah',
    confirm: 'Konfirmasi',
    priceUnit: 'KRW',
    completeReservation: 'Reservasi Berhasil Diajukan',
    completeReservationDesc:
      'Kami akan memberi tahu Anda setelah reservasi dikonfirmasi!',
    confirmReservation: 'Reservasi Selesai',
    confirmReservationDesc:
      'Silakan datang ke klinik sesuai jadwal reservasi.\nKami menunggu kedatangan Anda! 😊',

    includeVAT: '(Termasuk PPN)',
    excludeVAT: '(Belum termasuk PPN)',
    next: 'Lanjut',
    reservationHistories: 'Daftar Reservasi',
    consultingReservation: 'Kunjungan/Konsultasi',
    unitReservationProductEA: 'item',
    all: 'Semua',
    aiCodeRecommendProductFilter: 'Perawatan Rekomendasi 😀',
    exhibitionProductFilter: 'Perawatan Pameran 😀',
    feedbackAuthRequestSuccess:
      'Silakan masukkan 6 digit kode verifikasi yang dikirim ke ponsel Anda.',
    feedbackAuthRequestSuccessEmail:
      'Silakan masukkan 6 digit kode verifikasi yang dikirim ke email Anda.',
    noReservationHistories: 'Belum ada reservasi yang terdaftar',
    noProducts: 'Belum ada informasi perawatan yang terdaftar',
    reservationCustomerInfo: 'Informasi Pemesan',
    reservationCustomerName: 'Nama Pemesan',
    reservationCustomerPhone: 'Nomor Telepon',

    needConsultation: 'Perlu konsultasi',
    writeAnonymously: 'Tulis secara anonim',
    birth: 'Tanggal Lahir',
    birthInputGuide: 'Silakan masukkan tanggal lahir Anda',
    invalidBirthInputMessage: 'Silakan masukkan tanggal lahir yang benar.',
  },
  [LanguageCode.mn]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: 'Эмчилгээний цаг захиалах (анхны үзлэг)',
    drpetitFollowUpVisitBooking: 'Эмчилгээний цаг захиалах (давтан үзлэг)',
    logout: 'Баталгаажуулалт цуцлах',
    /**
     * Custom pages
     */
    nbomLandingTitle1: 'Таны гоо үзэсгэлэн цэцэглэх газар,',
    nbomLandingTitle2: 'with MeSOnBOM',
    nbomLandingReservationDescription: 'Хүлээлгүйгээр хурдан\nцаг захиалаарай.',

    /**
     * AI 코디 상담요청
     */
    completeChatRequest:
      'Хүсэлт амжилттай хүлээн авлаа.\nХариуцсан ажилтан шалгасны дараа аль болох хурдан хариу өгөх болно.',
    chatRequestWelcomeTitle:
      'Сайн байна уу!\nХариуцсан ажилтантай холбогдох шаардлагатай юу?',
    chatRequestWelcomeDesc:
      'Хариуцсан ажилтантай холбогдох хүсэлтийг эмнэлгийн ажлын цагт шалгаж, аль болох хурдан хариу өгөх болно.',
    connectChatRequired: 'Тийм, холбогдох шаардлагатай',
    connectChatLater: 'Үгүй, дараа дахин хийнэ',

    /**
     * 리뷰 질문
     */
    reviewCommentPlaceholder: 'Чөлөөтэй санал бодлоо бичнэ үү',
    visitDate: 'Айлчилсан огноо',
    reviewTitleService: 'Ерөнхий үйлчилгээнд сэтгэл хангалуун байсан уу?',
    reviewTitleTherapist: 'Мэргэжилтэнд сэтгэл хангалуун байсан уу?',
    reviewTitleDoctor: 'Эмч эелдэг байсан уу?',
    reviewTitleTreatment: 'Хийлгэсэн эмчилгээндээ сэтгэл хангалуун байсан уу?',
    reviewTitleConsultant: 'Зөвлөх эелдэг байсан уу?',
    reviewTitleVisit: 'Айлчлалын ерөнхий туршлагад сэтгэл хангалуун байсан уу?',
    reviewTitleReturn:
      'Эмнэлгээс гарсан ерөнхий туршлагад сэтгэл хангалуун байсан уу?',
    reviewTitleContent: 'Нэмэлт санал бодлоо бичнэ үү',
    addReview: 'Сэтгэгдэл бичих',
    completeReview: 'Сэтгэгдэл бичиж дууслаа',
    completeReviewDescription:
      '{partnerName}-д айлчилсанд баярлалаа!\nТаны бичсэн сэтгэгдэлд тулгуурлан\nилүү сайн үйлчилгээ үзүүлэхийг хичээх болно.',

    /**
     * 예약
     */
    noAvailableReservationTime: 'Захиалах боломжтой цаг байхгүй байна',
    unavailableTreatment: 'Захиалах боломжгүй эмчилгээ',
    productOptionUpdatedNotice:
      'Эмчилгээний мэдээлэл өөрчлөгдсөн тул шинэчлэгдлээ. Шалгаад дахин үргэлжлүүлнэ үү.',
    productOptionRemovedNotice:
      'Захиалах боломжгүй болсон эмчилгээг жагсаалтаас хаслаа.',
    noAvailableReservationTimeDesc1:
      'Тухайн өдөр эмч байхгүй тул захиалах боломжгүй байна.',
    noAvailableReservationTimeDesc2:
      'Өөр өдөр сонгох эсвэл эмчилгээгээ өөрчилнө үү.',
    productPriceNoticeDesc:
      'Үнэ нь мэдээллийн зорилгоор бөгөөд төлбөрийг газар дээр нь төлнө.',
    treatmentReservationTag: 'Эмчилгээний цаг захиалга',
    consultingReservationTag: 'Зөвлөгөөний цаг захиалга',
    noRecentReservation: 'Сүүлийн үзлэгийн түүх байхгүй байна',
    selectRecentReservationTitle: 'Сүүлд үзүүлсэн огноог сонгоно уу',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: 'Эмчилгээний чиглэл',
    selectedConsultingCategoryTitle: 'Нэмэлт зөвлөгөө',
    extraConsultingCategoryTitle: 'Нэмж авах боломжтой зөвлөгөө',
    extraConsultingCategoryTitlePostFix: '(Олон сонгож болно)',
    primaryTreatmentCategoryPlaceholder: 'Эмчилгээний чиглэл (1-р)',
    secondaryTreatmentCategoryPlaceholder: 'Эмчилгээний чиглэл (2-р)',
    revisitReservationButtonTitle: 'Дахин захиалах',
    treatmentReservationButtonTitle: 'Эмчилгээ захиалах',
    consultingReservationButtonTitle: 'Зөвлөгөө захиалах',
    selectReservationMenu: 'Захиалгын цэсээ сонгоно уу',
    bookAppointment: 'Эмчилгээний цаг захиалах',
    thisMonthEvent: 'Энэ сарын урамшуулал',
    reservationAvailable: 'Захиалах боломжтой',
    reservationUnavailable: 'Захиалах боломжгүй',
    reservedProducts: '{productOptionName} болон бусад {n}',
    noExpectPrice: 'Зөвлөгөөний дараа мэдээлнэ',
    reservationCancelPolicy1:
      'Захиалга хүлээгдэж буй төлөвт байхад захиалгын огноо, цагийг өөрчлөх, захиалгыг цуцлах боломжтой.',
    reservationCancelPolicy2:
      'Захиалга баталгаажсаны дараа огноо, цагийг өөрчлөх болон захиалгыг цуцлах боломжгүй. Очиж чадахгүй бол Channel Talk 1:1 зөвлөгөө эсвэл утсаар захиалгаа цуцална уу.',
    filterCategoriesAndEvents: 'Ангилал ба урамшуулал',
    reservationStatusCancel: 'Цуцлагдсан',
    reservationStatusRequest: 'Захиалгын хүсэлт',
    reservationStatusConfirm: 'Баталгаажсан',
    completeReservationCancel: 'Захиалга цуцлагдлаа',
    completeEditReservationDate: 'Захиалгын огноо амжилттай өөрчлөгдлөө',
    confirmCancelReservation: 'Захиалгыг цуцлах уу?',
    confirmEditReservation: 'Захиалгыг сонгосон огноо руу өөрчлөх үү?',
    cancel: 'Цуцлах',
    cancelReservation: 'Захиалга цуцлах',
    editReservation: 'Захиалга өөрчлөх',
    searchPlaceholder: 'Хайх үгээ оруулна уу',
    event: 'Урамшуулал',
    aiCodiRecommend: 'AI зөвлөхийн санал',
    allTermsAgreement: 'Бүх нөхцөлд зөвшөөрөх',
    termsEssential: '[Заавал]',
    termsOptional: '[Сонголтоор]',
    allTreatment: 'Бүх эмчилгээ',
    reservationLandingGreeting: 'Сайн байна уу🙂\n{partnerName} байна',
    reservationLandingDescription:
      'Доорх цэсээр дамжуулан цаг захиалахад туслая.',
    treatmentSelectReservation: 'Эмчилгээ сонгож захиалах',
    visitConsultingReservation: 'Давтан үзлэг / Айлчлалын зөвлөгөөний захиалга',
    reservationHistoriesButton: 'Захиалга харах / өөрчлөх / цуцлах',
    makeReservation: 'Цаг захиалах',
    reservationDetail: 'Захиалгын дэлгэрэнгүй',
    normalBusiness: 'Ердийн эмчилгээ',
    selectTime: 'Цаг сонгох',
    selectDate: 'Айлчлах огноо сонгох',
    selectTreatmentCategory: 'Эмчилгээний чиглэл сонгох',
    selectTreatmentCategoryDesc: 'Хүссэн эмчилгээний чиглэлээ сонгоно уу',
    requestReservation: 'Захиалгын хүсэлт',
    reservationVerifyTitle: 'Захиалгын мэдээллээ шалгана уу',
    reservationRequestNotice: 'Эмнэлэг шалгаад захиалгыг баталгаажуулна.',
    reservationDate: 'Захиалгын огноо',
    reservationDateTime: 'Захиалгын огноо, цаг',
    expectedPaymentPrice: 'Төлөх дүн',
    expectedPrice: 'Тооцоолсон үнэ',
    consultingMemo: 'Зөвлөгөөний хүсэлтийн агуулга',
    noConsultingMemo: 'Байхгүй',
    selectedTreatments: 'Сонгосон эмчилгээ',
    requestAuth: 'Баталгаажуулах хүсэлт',
    consultingMemoPlaceholder:
      'Арьсны асуудлаа урьдчилан бичвэл зөвлөгөөг илүү хурдан авах боломжтой.\nХамт ирэх хүн байвал тэдний нэрийг оруулна уу!',
    namePlaceholder: 'Нэрээ оруулна уу',
    firstNamePlaceholder: 'Нэр',
    lastNamePlaceHolder: 'Овог',
    passportNameGuideDescription:
      'Паспорт дээрх латин үсгээр бичигдсэн нэрээ хоосон зайг оролцуулан яг адилхан оруулна уу.',
    phonePlaceholder: 'Утасны дугаараа оруулна уу',
    emailPlaceholder: 'Имэйлээ оруулна уу',
    authNoPlaceholder: 'Баталгаажуулах кодоо оруулна уу',
    resendAuth: 'Дахин илгээх',
    resendAuthTimer: 'Дахин илгээх ({0} сек)',
    validationGuide: 'Шаардлагатай мэдээллээ зөв оруулна уу.',
    unitEA: 'ширхэг',
    confirm: 'Батлах',
    priceUnit: 'вон',
    completeReservation: 'Цаг захиалгын хүсэлт илгээгдлээ',
    completeReservationDesc:
      'Эмнэлэгт шалгасны дараа захиалга баталгаажихад мэдэгдэх болно!',
    confirmReservation: 'Цаг захиалга дууслаа',
    confirmReservationDesc:
      'Захиалсан цагтаа эмнэлэгт ирэхэд л болно.\nБид таныг хүлээж байх болно! 😊',

    includeVAT: '(НӨАТ орсон)',
    excludeVAT: '(НӨАТ ороогүй)',
    next: 'Дараах',
    reservationHistories: 'Захиалгын жагсаалт',
    consultingReservation: 'Айлчлал / Зөвлөгөө',
    unitReservationProductEA: 'ширхэг',
    all: 'Бүгд',
    aiCodeRecommendProductFilter: 'Санал болгосон эмчилгээ 😀',
    exhibitionProductFilter: 'Тусгай урамшууллын эмчилгээ 😀',
    feedbackAuthRequestSuccess:
      'Утсанд илгээсэн 6 оронтой баталгаажуулах кодыг оруулна уу.',
    feedbackAuthRequestSuccessEmail:
      'Имэйлд илгээсэн 6 оронтой баталгаажуулах кодыг оруулна уу.',
    noReservationHistories: 'Бүртгэлтэй захиалга байхгүй байна',
    noProducts: 'Бүртгэлтэй эмчилгээний мэдээлэл байхгүй байна',
    reservationCustomerInfo: 'Захиалагчийн мэдээлэл',
    reservationCustomerName: 'Захиалагчийн нэр',
    reservationCustomerPhone: 'Утасны дугаар',

    needConsultation: 'Зөвлөгөө авах шаардлагатай',
    writeAnonymously: 'Нэргүйгээр бичих',
    birth: 'Төрсөн огноо',
    birthInputGuide: 'Төрсөн огноогоо оруулна уу',
    invalidBirthInputMessage: 'Төрсөн огноог зөв оруулна уу.',
  },
  [LanguageCode.ru]: {
    /**
     * Dr. petit custom
     */
    drpetitFirstVisitBooking: 'Записаться на приём (первичный)',
    drpetitFollowUpVisitBooking: 'Записаться на приём (повторный)',
    logout: 'Выйти',
    /**
     * Custom pages
     */
    nbomLandingTitle1: 'Место, где расцветает ваша красота,',
    nbomLandingTitle2: 'with MeSOnBOM',
    nbomLandingReservationDescription: 'Запишитесь быстро,\nбез ожидания.',

    /**
     * AI 코디 상담요청
     */
    completeChatRequest:
      'Заявка принята.\nМы ответим как можно скорее после проверки.',
    chatRequestWelcomeTitle:
      'Здравствуйте!\nНужна связь с ответственным сотрудником?',
    chatRequestWelcomeDesc:
      'Мы проверим запрос в рабочее время клиники и ответим как можно быстрее.',
    connectChatRequired: 'Да, нужна связь',
    connectChatLater: 'Нет, в другой раз',

    /**
     * 리뷰 질문
     */
    reviewCommentPlaceholder: 'Напишите ваше мнение',
    visitDate: 'Дата визита',
    reviewTitleService: 'Насколько вы довольны общим уровнем обслуживания?',
    reviewTitleTherapist: 'Вы довольны работой специалиста?',
    reviewTitleDoctor: 'Был ли врач доброжелательным?',
    reviewTitleTreatment: 'Вы довольны полученной процедурой?',
    reviewTitleConsultant: 'Был ли консультант доброжелательным?',
    reviewTitleVisit: 'Вы довольны общим впечатлением от визита?',
    reviewTitleReturn: 'Вы довольны общим впечатлением от завершения визита?',
    reviewTitleContent: 'Напишите дополнительные замечания',
    addReview: 'Оставить отзыв',
    completeReview: 'Отзыв отправлен',
    completeReviewDescription:
      'Спасибо, что посетили {partnerName}!\nНа основе вашего отзыва мы будем улучшать сервис.',

    /**
     * 예약
     */
    noAvailableReservationTime: 'Нет доступного времени для записи',
    unavailableTreatment: 'Процедура недоступна для записи',
    productOptionUpdatedNotice:
      'Информация о процедуре изменилась и обновлена. Проверьте её и повторите попытку.',
    productOptionRemovedNotice:
      'Процедуры, на которые больше нельзя записаться, удалены из списка.',
    noAvailableReservationTimeDesc1:
      'В этот день запись невозможна, так как врач отсутствует.',
    noAvailableReservationTimeDesc2:
      'Выберите другой день или измените процедуры.',
    productPriceNoticeDesc:
      'Цены указаны для справки; оплата производится на месте.',
    treatmentReservationTag: 'Запись на процедуру',
    consultingReservationTag: 'Запись на консультацию',
    noRecentReservation: 'Нет недавних записей на приём',
    selectRecentReservationTitle: 'Выберите дату последнего приёма',
    selectRecentReservationTitlePostfix: '',
    treatmentCategoryTitle: 'Медицинское направление',
    selectedConsultingCategoryTitle: 'Дополнительная консультация',
    extraConsultingCategoryTitle: 'Доступные консультации',
    extraConsultingCategoryTitlePostFix: '(можно выбрать несколько)',
    primaryTreatmentCategoryPlaceholder: 'Медицинское направление (1-е)',
    secondaryTreatmentCategoryPlaceholder: 'Медицинское направление (2-е)',
    revisitReservationButtonTitle: 'Повторная запись по последнему приёму',
    treatmentReservationButtonTitle: 'Запись на процедуру',
    consultingReservationButtonTitle: 'Запись на консультацию',
    selectReservationMenu: 'Выберите раздел для записи',
    bookAppointment: 'Записаться на приём',
    thisMonthEvent: 'Акции этого месяца',
    reservationAvailable: 'Запись доступна',
    reservationUnavailable: 'Запись недоступна',
    reservedProducts: '{productOptionName} и ещё {n} шт.',
    noExpectPrice: 'Уточнить на консультации',
    reservationCancelPolicy1:
      'Пока заявка на рассмотрении, можно изменить дату и время записи или отменить её.',
    reservationCancelPolicy2:
      'После подтверждения записи изменить дату и время или отменить её нельзя. Если вы не сможете прийти, отмените запись через чат 1:1 в Channel Talk или по телефону.',
    filterCategoriesAndEvents: 'Категории и акции',
    reservationStatusCancel: 'Отменено',
    reservationStatusRequest: 'Заявка на запись',
    reservationStatusConfirm: 'Запись подтверждена',
    completeReservationCancel: 'Запись отменена',
    completeEditReservationDate: 'Дата записи изменена',
    confirmCancelReservation: 'Отменить запись?',
    confirmEditReservation: 'Изменить запись на выбранную дату?',
    cancel: 'Отмена',
    cancelReservation: 'Отменить запись',
    editReservation: 'Изменить запись',
    searchPlaceholder: 'Введите поисковый запрос',
    event: 'Акция',
    aiCodiRecommend: 'Рекомендация AI-консультанта',
    allTermsAgreement: 'Согласиться со всеми условиями',
    termsEssential: '[Обязательно]',
    termsOptional: '[Необязательно]',
    allTreatment: 'Все процедуры',
    reservationLandingGreeting: 'Здравствуйте 🙂\nЭто {partnerName}',
    reservationLandingDescription: 'Через меню ниже мы поможем вам с записью.',
    treatmentSelectReservation: 'Запись с выбором процедуры',
    visitConsultingReservation:
      'Запись на повторный приём / очную консультацию',
    reservationHistoriesButton: 'Просмотр / изменение / отмена записей',
    makeReservation: 'Записаться',
    reservationDetail: 'Подробности записи',
    normalBusiness: 'Приём ведётся',
    selectTime: 'Выберите время',
    selectDate: 'Выберите дату визита',
    selectTreatmentCategory: 'Выберите медицинское направление',
    selectTreatmentCategoryDesc: 'Выберите нужное направление',
    requestReservation: 'Отправить заявку',
    reservationVerifyTitle: 'Проверьте данные записи',
    reservationRequestNotice:
      'Запись будет подтверждена после проверки клиникой.',
    reservationDate: 'Дата записи',
    reservationDateTime: '[Данные записи]\nДата и время записи',
    expectedPaymentPrice: 'Сумма к оплате',
    expectedPrice: 'Предварительная стоимость',
    consultingMemo: 'Содержание заявки на консультацию',
    noConsultingMemo: 'Нет',
    selectedTreatments: 'Выбранные процедуры',
    requestAuth: 'Подтверждение',
    consultingMemoPlaceholder:
      'Заранее опишите проблемы с кожей, чтобы консультация прошла быстрее. Если с вами кто-то идёт, укажите и его имя!',
    namePlaceholder: 'Введите имя',
    firstNamePlaceholder: 'Имя',
    lastNamePlaceHolder: 'Фамилия',
    passportNameGuideDescription:
      'Пожалуйста, введите имя латиницей точно так, как оно указано в паспорте, включая пробелы.',
    phonePlaceholder: 'Введите номер телефона',
    emailPlaceholder: 'Введите email',
    authNoPlaceholder: 'Введите код подтверждения',
    resendAuth: 'Отправить повторно',
    resendAuthTimer: 'Отправить повторно ({0} с)',
    validationGuide: 'Введите необходимые данные правильно.',
    unitEA: 'шт.',
    confirm: 'Подтвердить',
    priceUnit: 'KRW',
    completeReservation: 'Подтверждаем вашу запись',
    completeReservationDesc: 'Мы сообщим, когда запись будет подтверждена!',
    confirmReservation: 'Запись оформлена',
    confirmReservationDesc:
      'Приходите в клинику в назначенное время. Ждём вас! 😊',

    includeVAT: '(с НДС)',
    excludeVAT: '(без НДС)',
    next: 'Далее',
    reservationHistories: 'Список записей',
    consultingReservation: 'Визит/консультация',
    unitReservationProductEA: 'шт.',
    all: 'Все',
    aiCodeRecommendProductFilter: 'Рекомендуемые процедуры 😀',
    exhibitionProductFilter: 'Процедуры по акции 😀',
    feedbackAuthRequestSuccess:
      'Введите 6-значный код подтверждения, отправленный на ваш телефон.',
    feedbackAuthRequestSuccessEmail:
      'Введите 6-значный код подтверждения, отправленный на ваш email.',
    noReservationHistories: 'Записей пока нет',
    noProducts: 'Нет зарегистрированных процедур',
    reservationCustomerInfo: 'Данные записавшегося',
    reservationCustomerName: 'Имя записавшегося',
    reservationCustomerPhone: 'Телефон',

    needConsultation: 'Нужна консультация',
    writeAnonymously: 'Написать анонимно',
    birth: 'Дата рождения',
    birthInputGuide: 'Введите дату рождения',
    invalidBirthInputMessage: 'Введите корректную дату рождения.',
  },
});

export default strings;
